import { render } from "./ProductList.vue?vue&type=template&id=5d60f013&scoped=true&ts=true"
import script from "./ProductList.vue?vue&type=script&lang=ts"
export * from "./ProductList.vue?vue&type=script&lang=ts"

import "./ProductList.vue?vue&type=style&index=0&id=5d60f013&scoped=true&lang=scss"

import exportComponent from "/home/christmasatourhouse-com/www/tickets/releases/202610123691/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d60f013"]])

export default __exports__